import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '../fragments';

export default gql`
  mutation actionSubscriptionAcknowledgmentEmail(
    $input: SubscriptionAcknowledgmentEmailActionInput!
  ) {
    actionSubscriptionAcknowledgmentEmail(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      sentAt
    }
  }
  ${ErrorMessageInfo}
`;
